export function getFileTypeFromName(fullName: string): string {
	const lastDotIndex = fullName.lastIndexOf('.')
	return fullName.slice(1 + lastDotIndex)
}
